module.exports = __webpack_public_path__ + "static/media/RUSSELL K. RED 150 SE LOUDSPEAKERS.9d9d1e97.png";